module.exports = __webpack_public_path__ + "static/img/advantage02.90dc3e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/advantage02.png
// module id = iIiK
// module chunks = 1